import { render, staticRenderFns } from "./FeatureUpdates.vue?vue&type=template&id=e1403e46&scoped=true&"
import script from "./FeatureUpdates.vue?vue&type=script&lang=js&"
export * from "./FeatureUpdates.vue?vue&type=script&lang=js&"
import style0 from "./FeatureUpdates.vue?vue&type=style&index=0&id=e1403e46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1403e46",
  null
  
)

export default component.exports